export enum GroupOptionEnum {
  GROUP_ON_PARTNERS = 'Recommended',
  NO_GROUPING = 'Classic',
}

export type GroupOption =
  | GroupOptionEnum.GROUP_ON_PARTNERS
  | GroupOptionEnum.NO_GROUPING;
